export default __webpack_public_path__ + "static/media/Arrow-1.c1509fef.svg";